// AngularJS
import 'angular';
import 'angular-cookies';
import 'angular-resource';
import 'angular-route';
// import 'angular-animate';

// polyfills

import 'reflect-metadata';
import 'zone.js/dist/zone';

// Angular
import '@angular/core';
import '@angular/upgrade';
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/common';
import '@angular/http';
import '@angular/router';

// RxJS
import 'rxjs';

import './modernizr-custom';
// Angulartics
import 'angulartics';
import 'angulartics-google-tag-manager';
import 'angulartics-google-analytics';

// Highcharts
import Highcharts from 'highcharts/highcharts.src.js';
import { default as HighchartsMore } from 'highcharts/highcharts-more.src.js';

// Webshim
import 'webshim/js-webshim/minified/polyfiller';
import 'webshim/js-webshim/minified/shims/i18n/formcfg-fr.js';
import 'webshim/js-webshim/minified/shims/i18n/formcfg-en.js';

// Text Angular

import 'textangular/dist/textAngular-sanitize.min';
import 'textangular/dist/textAngular.min';

// Bootstrap
import 'bootstrap/dist/js/bootstrap.min';
import 'angular-ui-bootstrap/ui-bootstrap-tpls.min';
import 'angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.min';
import 'ng-scrollbars/dist/scrollbars.min';

// Bootstrap Timepicker
import 'bootstrap-timepicker/js/bootstrap-timepicker.min';

// Moment
import 'moment-timezone/builds/moment-timezone.min';
import 'moment-timezone/builds/moment-timezone-with-data.min';

// NgPattern
import 'ng-pattern-restrict/src/ng-pattern-restrict.min';

// Drag-n-drop
import 'angular-drag-and-drop-lists/angular-drag-and-drop-lists.min';

import 'angular-intercom/angular-intercom';
import 'jquery-ui-dist/jquery-ui.min';
import 'bootstrap/dist/js/bootstrap.min';
import 'blockui-npm/jquery.blockUI';
import 'jquery-slimscroll/jquery.slimscroll.min';
import 'switchery/standalone/switchery';

HighchartsMore(Highcharts);
window.Highcharts = Highcharts;

// Scrollbars
require('jquery-mousewheel')($);
require('malihu-custom-scrollbar-plugin')($);



// WEBPACK FOOTER //
// ./web/dependencies/js/vendors.js